import axios from 'axios';

import { GenericDetailedError } from '~/errors/GenericDetailedError';
import type { ApiNFRTemplate } from '~/types/api-types';

export const NFRTemplateCacheKey = 'NFR_TEMPLATES';

export async function getAllNFRTemplates() {
  let cache = sessionStorage.getItem(NFRTemplateCacheKey);
  if (cache === null) {
    try {
      const res = await axios.get('/api/NFRTemplates');
      sessionStorage.setItem(NFRTemplateCacheKey, JSON.stringify(res.data));
      cache = sessionStorage.getItem(NFRTemplateCacheKey) as string;
    } catch (error) {
      throw new Error('Kunde inte hämta tidsdimensioner');
    }
  }
  return JSON.parse(cache) as ApiNFRTemplate[];
}

export async function getAllNFRTemplatesForSubmission(timeDimensionId: number) {
  try {
    const res = await axios.get(`/api/NFRTemplates/${timeDimensionId}`);
    return res.data as ApiNFRTemplate[];
  } catch (error: any) {
    throw new GenericDetailedError('Kunde inte hämta mallar', error.message);
  }
}

export async function importNFRTemplate(timeDimensionId: number, file: File) {
  try {
    const data = new FormData();
    data.append('file', file);
    const res = await axios.post(`/api/NFRTemplates/${timeDimensionId}`, data);
    return res.data as ApiNFRTemplate;
  } catch (error: any) {
    throw new GenericDetailedError('Kunde inte importera mall', error.message);
  }
}

export async function deleteNFRTemplate(NFRid: number) {
  try {
    await axios.delete(`/api/NFRTemplates/${NFRid}`);
  } catch (error: any) {
    throw new GenericDetailedError('Kunde inte ta bort mall', error.message);
  }
}
